import { Cart, StateUtils } from '@spartacus/core';

export const CLONE_CART = '[CustomCart] Clone Cart';
export const CLONE_CART_SUCCESS = '[CustomCart] Clone Cart Success';
export const CLONE_CART_FAIL = '[CustomCart] Clone Cart Fail';
export const CLONE_CART_RESET = '[CustomCart] Clone Cart Reset';

export class CloneCart extends StateUtils.LoaderLoadAction {
  readonly type = CLONE_CART;

  constructor(public payload: { cartGuid: string }) {
    super(CLONE_CART);
  }
}

export class CloneCartSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CLONE_CART_SUCCESS;

  constructor(public payload: Cart) {
    super(CLONE_CART);
  }
}

export class CloneCartFail extends StateUtils.LoaderFailAction {
  readonly type = CLONE_CART_FAIL;

  constructor(payload: any) {
    super(CLONE_CART, payload);
  }
}

export class CloneCartReset extends StateUtils.LoaderResetAction {
  readonly type = CLONE_CART_RESET;

  constructor() {
    super(CLONE_CART);
  }
}

export type CloneCartActions = CloneCart | CloneCartSuccess | CloneCartFail | CloneCartReset;
